import { NgModule } from '@angular/core';
import { ImgZoomDirective } from './img-zoom.directive';

@NgModule({
    declarations: [
        ImgZoomDirective
    ],
    imports: [],
    exports: [
        ImgZoomDirective
    ]
})
export class NcImgZoomModule { }